import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Box,
} from "@mui/material";
// import { Tooltip } from "antd";
import Tooltip from "@mui/material/Tooltip";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
import Collapse from "@mui/material/Collapse";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert, __esModule } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TimePicker } from "@mui/x-date-pickers/TimePicker"; // ✅ Added TimePicker
import Util from "../../validation";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import Checkbox from "@mui/material/Checkbox";
import LoaderButton from "../../components/CustomButton/LoaderButton.jsx";
import { useTranslation } from "react-i18next";

import {

    getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import {
    getRegenerateToken,
    resetRegenerateToken,
} from "../../redux/actions/regenerateTokenAction";
import Autocomplete from "@mui/material/Autocomplete";
import { createSettlementPartnerReport, resetCreateSettlementPartner } from "../../redux/actions/createSettlementPartnerAction";
import { getSettlementReportPartnerS } from "../../redux/actions/getSettlementPartnerAction"
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { downloadSettlementReportFileReq, resetDownloadSettlementReportPartner } from "../../redux/actions/downloadSettlementPartnerAction";


const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const SettlementReport = () => {
    // Returns a Date whose LOCAL getters (getHours/getMinutes/getSeconds/getFullYear/...)
    // return the current UTC date & time — so DatePicker/TimePicker *display* UTC "now".
    const getUtcNowForPicker = () => {
        const now = new Date();
        return new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    };
    var date = new Date();
    const classes = useStyles();

    // Date states
    const [selectedDate, setSelectedDate] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1)
    );
    const [selectedToDate, setSelectedToDate] = useState(new Date());
    const [addOpen, setAddOpen] = React.useState(false);
    const [spinner, setspinner] = useState(false);

    // ✅ Time states (defaults to start of day / current time)
    const [selectedTime, setSelectedTime] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0) // 00:00:00
    );
    // const [selectedToTime, setSelectedToTime] = useState(new Date());

    const [selectedToTime, setSelectedToTime] = useState(() => {
        const t = new Date();
        t.setHours(23, 59, 59, 0);
        return t;
    });
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);
    const [customerId, setCustomerId] = useState("");
    const [merchantId, setMerchantId] = useState("");
    const dispatch = useDispatch();
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    const [notificationType, setNotificationType] = useState(""); // "success" | "failed"
    const [notificationMessage, setNotificationMessage] = useState("");

    // const [dialogStartDate, setDialogStartDate] = useState(new Date());
    // const [dialogStartTime, setDialogStartTime] = useState(new Date());
    // const [dialogEndDate, setDialogEndDate] = useState(new Date());
    // const [dialogEndTime, setDialogEndTime] = useState(new Date());


    const [dialogStartDate, setDialogStartDate] = useState(getUtcNowForPicker());
    const [dialogStartTime, setDialogStartTime] = useState(getUtcNowForPicker());
    const [dialogEndDate, setDialogEndDate] = useState(getUtcNowForPicker());
    const [dialogEndTime, setDialogEndTime] = useState(getUtcNowForPicker());

    const [dialogMerchantId, setDialogMerchantId] = useState("");

    const [createFeeWalletResArray, setcreateFeeWalletResArray] = useState("");
    console.log("createFeeWalletResArray", createFeeWalletResArray)
    const [createFeeWalletStatus, setcreateFeeWalletStatus] = useState(false);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [getCustomerListStatus, setGetCustomerListStatus] = useState(false);
    const [getCustomerListArray, setGetCustomerListArray] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [settleId, setSettleId] = useState("");
    const [autocompleteCustomerIDData, setautocompleteCustomerIDData] =
        useState("");
    // const [autocompleteCustomerIDDataModal, setautocompleteCustomerIDDataModal] =
    //     useState("");
    const [autocompleteCustomerIDDataModal, setAutocompleteCustomerIDDataModal] = useState("");


    const login = useSelector((state) => state.login);
    console.log("login", login)

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    var authToken = regenerateTokenRes.data.AuthToken;


    // Date change handlers
    const handleDateChange = (newValue) => {
        setSelectedDate(newValue);
    };

    const handleToDateChange = (newValue) => {
        setSelectedToDate(newValue);
    };

    const handleNoticationClose = () => {
        setNotificationOpen(false);
        setNotificationType("");
        setNotificationMessage("");
        setAddOpen(false);
        setAutocompleteCustomerIDDataModal("");
        setSelectedCustomers([]);
        setDialogStartTime(new Date());
        // AFTER: reset to 11:59:59 PM
        const endOfDay = new Date();
        endOfDay.setHours(23, 59, 59, 0);
        // handleNoticationClose()
        setDialogStartTime(getUtcNowForPicker());
        setDialogEndTime(getUtcNowForPicker());
        // setSelectedToTime(endOfDay);  // ← was setSelectedToTime(new Date())
        // setDialogEndTime(new Date());
    };

    const getCustomerIdAndNameListRes = useSelector(
        ({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
    );
    console.log("getCustomerIdAndNameListRes", getCustomerIdAndNameListRes)
    const createSettlementReportRes = useSelector(
        ({ createSettlementsReports }) => createSettlementsReports
    );
    console.log("createSettlementReportRes", createSettlementReportRes)
    const Theme = useSelector((state) => state.theme.theme);


    const getSettlementReportRes = useSelector(
        ({ getSettlementsReportsData }) => getSettlementsReportsData
    );
    console.log("getSettlementReportRes", getSettlementReportRes)

    const downloadSettlementReportRes = useSelector(
        ({ downloadSettlementReportsData }) => downloadSettlementReportsData
    );



    // const combineDateAndTimeAsUtc = (datePart, timePart) => {
    //     if (!datePart || !timePart) return "";

    //     const localDateTime = new Date(
    //         datePart.getFullYear(),
    //         datePart.getMonth(),
    //         datePart.getDate(),
    //         timePart.getHours(),
    //         timePart.getMinutes(),
    //         timePart.getSeconds(),
    //         0
    //     );

    //     return moment.utc(localDateTime).format("YYYY-MM-DD HH:mm:ss");
    // };

    const combineDateAndTimeAsUtc = (datePart, timePart) => {
        if (!datePart || !timePart) return "";

        const pad = (n) => String(n).padStart(2, "0");

        const year = datePart.getFullYear();
        const month = pad(datePart.getMonth() + 1);
        const day = pad(datePart.getDate());

        const hours = pad(timePart.getHours());
        const minutes = pad(timePart.getMinutes());
        const seconds = pad(timePart.getSeconds());

        // Sent exactly as shown in the picker — no extra timezone conversion.
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    // ✅ Time change handlers
    const handleTimeChange = (newValue) => {
        setSelectedTime(newValue);
    };

    const handleToTimeChange = (newValue) => {
        console.log("newValue", newValue)
        setSelectedToTime(newValue);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = page * rowsPerPage;
        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };
    const handleChange = ({ target: { name, value } }) => {


        if (name === "merchantId") {
            // setTransactionId(value);
            Util.verifyNumber(value)
                ? setMerchantId(value)
                : setMerchantId(merchantId);
        }
        if (name === "settleId") {
            // ✅ Regex: allow only digits, reject anything else
            if (value === "" || /^\d+$/.test(value)) {
                setSettleId(value);
            }
        }
        // if (name === "settleId") {
        //     // ✅ Only allow numbers (same pattern as merchantId)
        //     Util.verifyNumber(value)
        //         ? setSettleId(value)
        //         : setSettleId(settleId);
        // }
    }


    const csv = "1";
    const pdf = "0";

    // ✅ Prevent double click with loading guard
    // const handleDownloadClick = (csvOrPdf) => {
    //   if (generateWalletTransactionReportFileRes.isLoading) return; // ✅ block double call
    //   getTransactionReportFileExcelOrPdf(csvOrPdf);
    // };
    const handleDownloadClick = (csvOrPdf, merchantId, rowStartDate, rowEndDate) => {
        if (downloadSettlementReportRes.isLoading) return;
        getDownloadSettlemnetFileExcelOrPdf(csvOrPdf, merchantId, rowStartDate, rowEndDate);
    };

    const getDownloadSettlemnetFileExcelOrPdf = (csvOrPdf, merchantId, rowStartDate, rowEndDate) => {
        const fileType = csvOrPdf === "1" ? "csv" : "pdf";

        // const combineDateAndTime = (date, time) => {
        //     if (!date || !time) return "";

        //     const datePart = moment(date).format("YYYY-MM-DD");  
        //     const timePart = moment(time).format("HH:mm:ss");

        //     return `${datePart} ${timePart}`;
        // };
        // const formattedStartDateTime = combineDateAndTime(selectedDate, selectedTime);
        // const formattedEndDateTime = combineDateAndTime(selectedToDate, selectedToTime);

        const requestObj = {
            loginDetails: {
                walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
                // customerId: ""
                // customerId: autocompleteCustomerIDData ? autocompleteCustomerIDData.split('-')[0] : "",
                customerId: merchantId || ""
            },

            actionCustomerMasterRequestVO: {
                startDate: rowStartDate || "",
                endDate: rowEndDate || "",
                reportFileType: fileType,
            },
        };

        dispatch(
            downloadSettlementReportFileReq(
                requestObj,
                authToken,
                fileType
            )
        );
    };

    useEffect(() => {
        if (!downloadSettlementReportRes.success) return;

        const blob = downloadSettlementReportRes.data?.blob;
        if (!blob) return;

        console.log("✅ Downloading file:", blob);

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        // 🔥 detect type
        let extension = "csv";

        if (blob.type.includes("zip")) extension = "zip";
        else if (blob.type.includes("pdf")) extension = "pdf";

        link.download = `SettlementReport.${extension}`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);

        dispatch(resetDownloadSettlementReportPartner());

    }, [downloadSettlementReportRes]);

    const GetSettlementListRequest = () => {
        setGetCustomerListStatus(true);
        setIsLoading(true);
        setspinner(true);
        // Helper to combine date + time into "YYYY-MM-DD HH:mm:ss"
        // const combineDateAndTime = (date, time) => {
        //     if (!date || !time) return "";

        //     const datePart = moment(date).format("YYYY-MM-DD");
        //     const timePart = moment(time).format("HH:mm:ss");

        //     return `${datePart} ${timePart}`;
        // };
        // const formattedStartDateTime = combineDateAndTime(selectedDate, selectedTime);
        // const formattedEndDateTime = combineDateAndTime(selectedToDate, selectedToTime);
        const formattedStartDateTime = combineDateAndTimeAsUtc(selectedDate, selectedTime);
        const formattedEndDateTime = combineDateAndTimeAsUtc(selectedToDate, selectedToTime);


        // Format date as "2026-03-15" and time as "21:18:53"
        // const formattedStartDate = selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : "";
        // const formattedStartTime = selectedTime ? moment(selectedTime).format("HH:mm:ss") : "";
        // const formattedEndDate = selectedToDate ? moment(selectedToDate).format("YYYY-MM-DD") : "";
        // const formattedEndTime = selectedToTime ? moment(selectedToTime).format("HH:mm:ss") : "";


        const req = {

            loginDetails: {
                walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
                // customerId: ""
                customerId: autocompleteCustomerIDData ? autocompleteCustomerIDData.split('-')[0] : ""
            },
            actionCustomerMasterRequestVO: {
                startDate: formattedStartDateTime,  // "2026-03-15 21:18:53"
                endDate: formattedEndDateTime,       // "2026-03-15 21:18:53"
                settledId: settleId

            }
        };
        // console.log("getSettlementReq", req)
        return dispatch(getSettlementReportPartnerS(req, authToken));
    };


    const getSettlementListStatusFunc = () => {
        if (getSettlementReportRes.data.status == "success") {
            setIsLoading(false);
            setGetCustomerListArray(
                [].concat(getSettlementReportRes.data.settlementVOS)
            );
        }
        if (getSettlementReportRes.data.status == "Failed") {
            NotificationPopups("error", "Failed", getSettlementReportRes.data.description);
            setIsLoading(false);
            setGetCustomerListArray(getSettlementReportRes.data);
            if (
                getSettlementReportRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getSettlementReportRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
        if (getSettlementReportRes.data.status == "failed") {
            NotificationPopups("error", "Failed", getSettlementReportRes.data.description);
            setIsLoading(false);
            setGetCustomerListArray(getSettlementReportRes.data);
            if (
                getSettlementReportRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getSettlementReportRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                GetSettlementListRequest()
            }
        }
        if (
            !getSettlementReportRes.data.status &&
            getSettlementReportRes.data.description === "Not Found"
        ) {
            setIsLoading(false);
            setGetCustomerListArray([]); // ✅ empty array triggers "No Records Found" UI
        }
        if (getSettlementReportRes.data.status == "Not Found" ||
            getSettlementReportRes.data.status == "NOT FOUND") {
            setIsLoading(false);
            NotificationPopups("error", "Failed", getSettlementReportRes.data.description)
        }
    };

    useEffect(() => {
        if (getSettlementReportRes.data.status == "success") {
            setPage(0);
        }
    }, [getSettlementReportRes.data.status]);

    // useEffect(() => {
    //     if (getSettlementReportRes.data.status == "Success") {
    //         setPage(0);
    //     }
    // }, [getSettlementReportRes.data.status]);

    // useEffect(() => {
    //     if (getCustomerListStatus) {
    //         getSettlementListStatusFunc();
    //     }
    // }, [getSettlementReportRes.data.status]);
    useEffect(() => {
        if (getCustomerListStatus) {
            getSettlementListStatusFunc();
        }
    }, [getSettlementReportRes.data])


    const customerIds = selectedCustomers.map(
        (item) => item.split("-")[0]
    );
    const createSettlementFun = () => {
        setcreateFeeWalletStatus(true);


        // ── Helper: merge a Date (date part) + Date (time part) → "yyyy-mm-dd hh:mm:ss"
        // const combineDateAndTime = (datePart, timePart) => {
        //     if (!datePart || !timePart) return "";

        //     const year = datePart.getFullYear();
        //     const month = String(datePart.getMonth() + 1).padStart(2, "0");
        //     const day = String(datePart.getDate()).padStart(2, "0");

        //     const hours = String(timePart.getHours()).padStart(2, "0");
        //     const minutes = String(timePart.getMinutes()).padStart(2, "0");
        //     const seconds = String(timePart.getSeconds()).padStart(2, "0");

        //     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        // };

        const createSettlementReq = {
            loginDetails: {
                walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
                // customerId: ""
                // customerId: autocompleteCustomerIDDataModal ? autocompleteCustomerIDDataModal.split('-')[0] : ""
                merchantIds: customerIds
            },
            actionCustomerMasterRequestVO: {
                startDate: combineDateAndTimeAsUtc(dialogStartDate, dialogStartTime),
                endDate: combineDateAndTimeAsUtc(dialogEndDate, dialogEndTime),
                // startDate: combineDateAndTime(dialogStartDate, dialogStartTime), // e.g. "2025-05-01 09:30:00"
                // endDate: combineDateAndTime(dialogEndDate, dialogEndTime),   // e.g. "2025-05-19 18:45:00"


            }
        };
        console.log("DirectLOOO", createSettlementReq)

        return dispatch(createSettlementPartnerReport(createSettlementReq, authToken));
    };

    // useEffect(() => {
    //     if (!createSettlementReportRes || !createSettlementReportRes.data) return;

    //     const status = createSettlementReportRes.data.status;
    //     const description = createSettlementReportRes.data.description;

    //     if (!status) return;

    //     if (status.toLowerCase() === "success") {
    //         // ✅ FIX 2 & 3: Use description from API response in popup
    //         setNotificationType("success");
    //         setNotificationMessage(description || "Created Successfully");
    //         setNotificationOpen(true);
    //     } else if (status.toLowerCase() === "failed") {
    //         // ✅ FIX 3: Single handler for all failed cases (covers "failed" and "Failed")
    //         setNotificationType("failed");
    //         setNotificationMessage(description || "Update Record Failed");
    //         setNotificationOpen(true);

    //         if (description === "session out") {
    //             SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //         if (description === "Authorization failed") {
    //             regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //     }
    // }, [createSettlementReportRes]);


    useEffect(() => {
        if (!createSettlementReportRes || !createSettlementReportRes.data) return;

        const status = createSettlementReportRes.data.status;
        const description = createSettlementReportRes.data.description;

        if (!status) return;

        // ✅ KEY FIX: Only show popup if user triggered this action in current session
        if (!createFeeWalletStatus) return;

        if (status.toLowerCase() === "success") {
            setNotificationType("success");
            setNotificationMessage(description || "Created Successfully");
            setNotificationOpen(true);
            GetSettlementListRequest(); // ✅ Refresh list after successful creation
            setcreateFeeWalletStatus(false); // ✅ Reset flag after handling
        } else if (status.toLowerCase() === "failed" || status.toLowerCase() === "fail") {
            setNotificationType("failed");
            setNotificationMessage(description || "Update Record Failed");
            setNotificationOpen(true);
            setcreateFeeWalletStatus(false); // ✅ Reset flag after handling

            if (description === "session out") {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (description === "Authorization failed") {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [createSettlementReportRes]);

    // ✅ Reset stale Redux state when component mounts
    useEffect(() => {
        dispatch(resetCreateSettlementPartner());
    }, []);
    // const createSettlementStatusFunc = () => {
    //     if (createFeeWalletStatus) {
    //         if (createSettlementReportRes.data.status == "success") {
    //             setNotificationOpen(true);
    //             setcreateFeeWalletResArray(createSettlementReportRes.data.status);
    //         }
    //         if (createSettlementReportRes.data.status == "Failed") {
    //             setNotificationOpen(true);
    //             setcreateFeeWalletResArray(createSettlementReportRes.data.status);
    //             if (
    //                 createSettlementReportRes.data.description == "session out"
    //             ) {
    //                 SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //             if (
    //                 createSettlementReportRes.data.description == "Authorization failed"
    //             ) {
    //                 regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //         }
    //         if (createSettlementReportRes.data.status == "failed") {
    //             setNotificationOpen(true);
    //             setcreateFeeWalletResArray(createSettlementReportRes.data.status);
    //             if (
    //                 createSettlementReportRes.data.description == "session out"
    //             ) {
    //                 SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //             if (
    //                 createSettlementReportRes.data.description == "Authorization failed"
    //             ) {
    //                 regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //         }
    //     }
    // };

    useEffect(() => {
        if (getCustomerIdAndNameListRes.data.status === "Success") {
            // console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
        }
    }, [getCustomerIdAndNameListRes.data.status])

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            const getCustomerIdAndNameReq = {
                loginDetails: {
                    walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
                },
                actionCustomerMasterRequestVO: {
                    customerNameOrId: ""
                }
            };

            dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);

    const filterOptionsLM = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) =>
                option.includes(inputValue) ||
                ""
        );

        return filterOptionsList.slice(0, 20);
    }

    const filterOptionsL = (options, { inputValue }) => {
        if (!inputValue) {
            return options.slice(0, 20);
        }

        if (inputValue.length < 3) {
            return [];
        }

        return options
            .filter((option) =>
                option.toLowerCase().includes(inputValue.toLowerCase())
            )
            .slice(0, 20);
    };

    const addRole = (e) => {

        setAddOpen(true);

    };



    const handleClose = () => {
        // setAddOpen(false);

        // ✅ Reset dialog fields on close
        // handleClose()
        setDialogStartDate(getUtcNowForPicker());
        setDialogStartTime(getUtcNowForPicker());
        setDialogEndDate(getUtcNowForPicker());
        setDialogEndTime(getUtcNowForPicker());
        // setDialogStartDate(new Date());
        // setDialogStartTime(new Date());
        // setDialogEndDate(new Date());
        // setDialogEndTime(new Date());
        // setDialogMerchantId("");
        // setAutocompleteCustomerIDDataModal("");
        // setSelectedCustomers([]);

    }

    // Refresh dialog Start/End date-time to current UTC every time the dialog opens
    useEffect(() => {
        if (addOpen) {
            setDialogStartDate(getUtcNowForPicker());
            setDialogStartTime(getUtcNowForPicker());
            setDialogEndDate(getUtcNowForPicker());
            setDialogEndTime(getUtcNowForPicker());
        }
    }, [addOpen]);
    const handleCancel = () => {
        setAddOpen(false);
    }

    useEffect(() => {
        if (
            regenerateTokenRes.data.status === "success" &&
            regenerateTokenRes.data.AuthToken
        ) {
            getSettlementReportPartnerS();
        }
    }, []);




    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px"
                        }}
                    >
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "12px"
                                }}
                                // onClick={() => addRole()}
                                onClick={() => setAddOpen(true)} // ✅ FIX 1: was addRole() — undefined

                            >
                                Create Settlements
                            </CustomButton>


                        </Grid>
                    </Grid>
                    <LocalizationProvider dateAdapter={AdapterDateFns}> {/* ✅ Wrap once at top level */}
                        <Grid
                            container
                            spacing={2}
                            style={{ padding: "25px", marginTop: "2rem" }}
                        >
                            {/* ───── Start Date ───── */}
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <DatePicker
                                        label="Start Dates"
                                        format="MM/dd/yyyy"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        disableFuture={true}
                                    />
                                </FormControl>
                            </Grid>

                            {/* ✅ Start Time — placed right after Start Date */}
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    {/* <TimePicker
                                        label="Start Time"
                                        value={selectedTime}
                                        onChange={handleTimeChange}
                                    /> */}

                                    <TimePicker
                                        label="Start Time"
                                        value={selectedTime}
                                        onChange={handleTimeChange}
                                        views={["hours", "minutes", "seconds"]}
                                        timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                                        // format="hh:mm:ss aa"
                                        ampm={false}
                                        format="HH:mm:ss"

                                    />
                                </FormControl>

                            </Grid>

                            {/* ───── End Date ───── */}
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <DatePicker
                                        label="End Date"
                                        format="MM/dd/yyyy"
                                        value={selectedToDate}
                                        onChange={handleToDateChange}
                                        disableFuture={true}
                                        minDate={selectedDate}
                                    />
                                </FormControl>
                            </Grid>

                            {/* ✅ End Time — placed right after End Date */}
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <FormControl fullWidth>
                                    {/* <TimePicker
                                        label="End TimeS"
                                        value={selectedToTime}
                                        onChange={handleToTimeChange}
                                    /> */}

                                    <TimePicker
                                        label="End Time"
                                        value={selectedToTime}
                                        onChange={handleToTimeChange}
                                        views={["hours", "minutes", "seconds"]}
                                        timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                                        // format="hh:mm:ss aa"
                                        ampm={false}
                                        format="HH:mm:ss"
                                    />
                                </FormControl>
                            </Grid>



                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <Autocomplete
                                  
                                    id="combo-box-demo"
                                    options={[].concat(
                                        getCustomerIdAndNameListRes.data.currencyList || [""]
                                    )}
                                    getOptionLabel={(option) => option}
                                    filterOptions={filterOptionsLM}
                                    value={autocompleteCustomerIDData}
                                    onChange={(event, value) =>
                                        setautocompleteCustomerIDData(value)
                                    } 
                                    className="MerchantIDS"
                                    renderInput={(params) => (

                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            id="name"
                                            label="Merchant ID"
                                            // style={{ marginTop: "3px" }}
                                            // required
                                            type="text"
                                            fullWidth
                                            {...params}
                                            className="new1"
                                            // value={getCustomerId || ""}
                                            // name="getCustomerId"
                                            onBlur={handleChange}
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                    borderBottomColor: "gray", // White color for the underline before focus
                                                },
                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                    borderBottomColor: "gray", // White color on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                    borderBottomColor: "gray", // White color after focus
                                                },
                                            }}
                                            variant="standard"
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Settle Id"
                                    type="tel"
                                    fullWidth
                                    value={settleId}
                                    name="settleId"
                                    onChange={handleChange}
                                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
                                    variant="standard"
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>

                                <CustomButton
                                    style={{
                                        padding: "8px",
                                        marginLeft: "15px",
                                        marginTop: "16px",

                                    }}
                                    type="submit"
                                    color="primary"
                                    // round
                                    // className="buttons"
                                    onClick={GetSettlementListRequest}
                                    disabled={getSettlementReportRes.isLoading}
                                >
                                    <LoaderButton
                                        isLoading={getSettlementReportRes.isLoading}
                                        spinner={spinner}
                                    >
                                        {t("Search")}
                                        <SearchIcon style={{ marginLeft: "5px" }} />
                                    </LoaderButton>
                                </CustomButton>
                                {/* <CustomButton
                                   
                                    style={{
                                        padding: "8px",
                                        marginLeft: "15px",
                                        marginTop: "16px",

                                    }}
                                    onClick={GetSettlementListRequest}
                                    disabled={isLoading} // ✅ prevent double-click
                                >
                                    Search{" "}
                                    {isLoading ? (

                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                            style={{ marginLeft: "6px", width: "16px", height: "16px" }}
                                        />


                                    ) : (
                                        <SearchIcon />
                                    )}
                               
                                </CustomButton> */}
                            </Grid>
                        </Grid>
                    </LocalizationProvider>
                </Card>


                {isLoading ? (
                    <LoadingSpinner />

                ) : getCustomerListArray.length == 0 ||
                    getCustomerListArray.status == "Failed" ||
                    getCustomerListStatus == false ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Settlement Report
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Settlement Report
                                </Typography>
                            </Grid>
                            {/* <Grid
                                container
                                style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    justifyContent: "right"
                                }}
                            >
                                <Grid item xs={4} sm={4} md={1} lg={1}>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/${Theme}/excel.png`}
                                        alt="m-transact"
                                        style={{
                                            height: "30px",
                                            cursor: downloadSettlementReportRes.isLoading
                                                ? "not-allowed"   // ✅ show disabled cursor while loading
                                                : "pointer",
                                            opacity: downloadSettlementReportRes.isLoading ? 0.5 : 1,
                                        }}
                                        onClick={() => handleDownloadClick(csv)} // ✅ guarded click

                                    // style={{ height: "30px", cursor: "pointer" }}
                                    // onClick={() => {
                                    // 	getTransactionReportFileExcelOrPdf(csv);
                                    // }}
                                    />
                                </Grid>
                                {/* <Grid item xs={4} sm={4} md={1} lg={1}>
                                                                    <img
                                                                        src={`${process.env.PUBLIC_URL}/${Theme}/pdf1.png`}
                                                                        alt="m-transact"
                            
                                                                        style={{ height: "30px", cursor: "pointer" }}
                                                                        onClick={() => {
                                                                            getTransactionReportFileExcelOrPdf(pdf);
                                                                        }}
                                                                    />
                                                                </Grid> */}
                            {/* </Grid>  */}
                            <TableContainer component={Paper} className="my-3 ">
                                <Table
                                    className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Settle Id{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Merchant Id{" "}
                                            </TableCell>

                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Start Date{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                End Date{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Gross Amount{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Fee Amount
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Vat Amount
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Other Fee
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Settlement Amount{" "}
                                            </TableCell>

                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Fee Currency
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Action
                                            </TableCell>


                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {getCustomerListArray &&
                                            []
                                                .concat(getCustomerListArray)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">
                                                            {row.settledId ? row.settledId : '-'}
                                                        </TableCell>
                                                        <TableCell
                                                            className="themeColor"
                                                            style={{
                                                                marginTop: "1rem",
                                                                cursor: "pointer",
                                                                fontWeight: "600"
                                                            }}
                                                            align="center"
                                                        // onClick={() => sendCustomerId(row.customerId)}
                                                        >
                                                            {row.merchantId}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            {row.startDate ? row.startDate : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.endDate ? row.endDate : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.grossAmount ? row.grossAmount : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.feeAmount ? row.feeAmount : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.vatAmount ? row.vatAmount : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.settlementFee ? row.settlementFee : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.settlementAmount ? row.settlementAmount : '-'}
                                                        </TableCell>


                                                        <TableCell align="center">
                                                            {row.feeCurrency ? row.feeCurrency : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: "12px"
                                                                }}
                                                            >
                                                                {/* Excel Download */}
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/${Theme}/excel.png`}
                                                                    alt="excel"
                                                                    style={{
                                                                        height: "28px",
                                                                        cursor: downloadSettlementReportRes.isLoading
                                                                            ? "not-allowed"
                                                                            : "pointer",
                                                                        opacity: downloadSettlementReportRes.isLoading ? 0.5 : 1,
                                                                    }}
                                                                    onClick={() => {
                                                                        if (!downloadSettlementReportRes.isLoading) {
                                                                            handleDownloadClick("1", row.merchantId, row.startDate, row.endDate);
                                                                        }
                                                                    }}
                                                                />

                                                                {/* PDF Download */}
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/${Theme}/pdf1.png`}
                                                                    alt="pdf"
                                                                    style={{
                                                                        height: "28px",
                                                                        cursor: downloadSettlementReportRes.isLoading
                                                                            ? "not-allowed"
                                                                            : "pointer",
                                                                        opacity: downloadSettlementReportRes.isLoading ? 0.5 : 1,
                                                                    }}
                                                                    onClick={() => {
                                                                        if (!downloadSettlementReportRes.isLoading) {
                                                                            handleDownloadClick("0", row.merchantId, row.startDate, row.endDate);
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </TableCell>

                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={getCustomerListArray.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}

            </Layout>

            <div>
                <Dialog open={addOpen} onClose={handleClose}
                    fullWidth
                    maxWidth="md"
                    PaperProps={{
                        sx: {
                            width: "850px",
                            maxWidth: "90vw",
                            borderRadius: "8px",
                        },
                    }}
                >
                    <DialogTitle
                        sx={{
                            fontSize: "30px",
                            fontWeight: 500,
                        }}
                    >Create Settlement</DialogTitle>
                    <DialogContent>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid container spacing={3} sx={{ mt: 1 }}>

                                {/* ───── Dialog Start Date ───── */}
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <DatePicker
                                            label="Start Date"
                                            format="MM/dd/yyyy"
                                            value={dialogStartDate}
                                            onChange={(newValue) => setDialogStartDate(newValue)}
                                            disableFuture={true}
                                            slotProps={{
                                                textField: {
                                                    variant: "standard",
                                                    InputLabelProps: { sx: { color: "gray" } },
                                                    InputProps: {
                                                        sx: {
                                                            "&:before": { borderBottomColor: "gray" },
                                                            "&:after": { borderBottomColor: "gray" },
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* ───── Dialog Start Time ───── */}
                                {/* <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        {/* <TimePicker
                                            label="Start Time"
                                            value={dialogStartTime}
                                            onChange={(newValue) => setDialogStartTime(newValue)}
                                            slotProps={{
                                                textField: {
                                                    variant: "standard",
                                                    InputLabelProps: { sx: { color: "gray" } },
                                                    InputProps: {
                                                        sx: {
                                                            "&:before": { borderBottomColor: "gray" },
                                                            "&:after": { borderBottomColor: "gray" },
                                                        },
                                                    },
                                                },
                                            }}
                                        /> */}
                                {/* <TimePicker
                                            label="Start Time"
                                            value={dialogStartTime}
                                            onChange={(newValue) => setDialogStartTime(newValue)}
                                            views={["hours", "minutes", "seconds"]}   // ✅ Add seconds view
                                            timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}  // ✅ Step by 1 second
                                            ampm={false}
                                            format="HH:mm:ss"
                                            slotProps={{
                                                textField: {
                                                    variant: "standard",
                                                    InputLabelProps: { sx: { color: "gray" } },
                                                    InputProps: {
                                                        sx: {
                                                            "&:before": { borderBottomColor: "gray" },
                                                            "&:after": { borderBottomColor: "gray" },
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>  */}
                                {/* ───── Dialog Start Time ───── */}
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1 }}>
                                        <FormControl fullWidth>
                                            <TimePicker
                                                label="Start Time"
                                                value={dialogStartTime}
                                                onChange={(newValue) => setDialogStartTime(newValue)}
                                                views={["hours", "minutes", "seconds"]}
                                                timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                                                ampm={false}
                                                format="HH:mm:ss"
                                                slotProps={{
                                                    textField: {
                                                        variant: "standard",
                                                        InputLabelProps: { sx: { color: "gray" } },
                                                        InputProps: {
                                                            sx: {
                                                                "&:before": { borderBottomColor: "gray" },
                                                                "&:after": { borderBottomColor: "gray" },
                                                            },
                                                        },
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                        <Typography
                                            variant="caption"
                                            sx={{ color: "gray", whiteSpace: "nowrap", mb: "6px" }}
                                        >
                                            UTC
                                        </Typography>
                                    </Box>
                                </Grid>

                                {/* ───── Dialog End Date ───── */}
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <DatePicker
                                            label="End Date"
                                            format="MM/dd/yyyy"
                                            value={dialogEndDate}
                                            onChange={(newValue) => setDialogEndDate(newValue)}
                                            disableFuture={true}
                                            minDate={dialogStartDate}
                                            slotProps={{
                                                textField: {
                                                    variant: "standard",
                                                    InputLabelProps: { sx: { color: "gray" } },
                                                    InputProps: {
                                                        sx: {
                                                            "&:before": { borderBottomColor: "gray" },
                                                            "&:after": { borderBottomColor: "gray" },
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* ───── Dialog End Time ───── */}
                                {/* <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        {/* <TimePicker
                                            label="End Time"
                                            value={dialogEndTime}
                                            onChange={(newValue) => setDialogEndTime(newValue)}
                                            slotProps={{
                                                textField: {
                                                    variant: "standard",
                                                    InputLabelProps: { sx: { color: "gray" } },
                                                    InputProps: {
                                                        sx: {
                                                            "&:before": { borderBottomColor: "gray" },
                                                            "&:after": { borderBottomColor: "gray" },
                                                        },
                                                    },
                                                },
                                            }}
                                        /> */}
                                {/* <TimePicker
                                            label="End Time"
                                            value={dialogEndTime}
                                            onChange={(newValue) => setDialogEndTime(newValue)}
                                            views={["hours", "minutes", "seconds"]}   // ✅ Add seconds view
                                            timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}  // ✅ Step by 1 second
                                            ampm={false}
                                            format="HH:mm:ss"
                                            slotProps={{
                                                textField: {
                                                    variant: "standard",
                                                    InputLabelProps: { sx: { color: "gray" } },
                                                    InputProps: {
                                                        sx: {
                                                            "&:before": { borderBottomColor: "gray" },
                                                            "&:after": { borderBottomColor: "gray" },
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>  */}
                                {/* ───── Dialog End Time ───── */}
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1 }}>
                                        <FormControl fullWidth>
                                            <TimePicker
                                                label="End Time"
                                                value={dialogEndTime}
                                                onChange={(newValue) => setDialogEndTime(newValue)}
                                                views={["hours", "minutes", "seconds"]}
                                                timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                                                ampm={false}
                                                format="HH:mm:ss"
                                                slotProps={{
                                                    textField: {
                                                        variant: "standard",
                                                        InputLabelProps: { sx: { color: "gray" } },
                                                        InputProps: {
                                                            sx: {
                                                                "&:before": { borderBottomColor: "gray" },
                                                                "&:after": { borderBottomColor: "gray" },
                                                            },
                                                        },
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                        <Typography
                                            variant="caption"
                                            sx={{ color: "gray", whiteSpace: "nowrap", mb: "6px" }}
                                        >
                                            UTC
                                        </Typography>
                                    </Box>
                                </Grid>

                                {/* ───── Dialog Merchant Id ───── */}
                                {/* <Grid item xs={12}>
                                    <TextField
                                        margin="dense"
                                        id="dialogMerchantId"
                                        label="Merchant Id"
                                        type="tel"
                                        fullWidth
                                        value={dialogMerchantId}
                                        name="dialogMerchantId"
                                        onChange={(e) => {
                                            const onlyNums = e.target.value.replace(/\D/g, "");
                                            setDialogMerchantId(onlyNums);
                                        }}
                                        style={{ marginTop: "3px" }}
                                        variant="standard"
                                        inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            maxLength: 20,
                                        }}
                                        InputProps={{
                                            sx: {
                                                "&:before": { borderBottomColor: "gray" },
                                                "&:after": { borderBottomColor: "gray" },
                                            },
                                        }}
                                        InputLabelProps={{
                                            sx: { color: "gray" },
                                        }}
                                    />
                                </Grid> */}

                                <Grid item xs={12} >
                                    {/* <Autocomplete
                                    
                                        id="combo-box-demo"
                                        options={[].concat(
                                            getCustomerIdAndNameListRes.data.currencyList || [""]
                                        )}
                                        getOptionLabel={(option) => option}
                                        filterOptions={filterOptionsL}
                                        value={autocompleteCustomerIDDataModal}
                                        onChange={(event, value) =>
                                            setAutocompleteCustomerIDDataModal(value)
                                        }

                                        renderInput={(params) => (

                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                id="name"
                                                label="Merchant ID"
                                                // style={{ marginTop: "3px" }}
                                                // required
                                                type="text"
                                                fullWidth
                                                {...params}
                                                className="new1"
                                                // value={getCustomerId || ""}
                                                // name="getCustomerId"
                                                onBlur={handleChange}
                                                sx={{
                                                    "& .MuiInput-underline:before": {
                                                        borderBottomColor: "gray", // White color for the underline before focus
                                                    },
                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                        borderBottomColor: "gray", // White color on hover
                                                    },
                                                    "& .MuiInput-underline:after": {
                                                        borderBottomColor: "gray", // White color after focus
                                                    },
                                                }}
                                                variant="standard"
                                            />
                                        )}
                                    /> */}

                                    <Autocomplete
                                        multiple
                                        disableCloseOnSelect
                                        filterSelectedOptions
                                        options={getCustomerIdAndNameListRes.data.currencyList || []}
                                        value={selectedCustomers}
                                        onChange={(event, newValue) => {
                                            setSelectedCustomers(newValue);
                                        }}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox checked={selected} />
                                                {option}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Merchant ID"
                                                variant="standard"
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* Note:<p>Start date will be considered from last settlement end date for each merchant.</p> */}

                            </Grid>
                        </LocalizationProvider>
                        <Typography
                            variant="body2"
                            sx={{
                                mt: 3,
                                color: "#616161",
                                fontSize: "14px",
                                lineHeight: 1.6,
                                backgroundColor: "#f5f5f5",
                                padding: "10px 12px",
                                borderRadius: "4px",
                                borderLeft: "4px solid #1976d2",
                            }}
                        >
                            <strong>Note:</strong> Start date will be considered from the
                            last settlement end date for each merchant.
                        </Typography>
                        {/* <p>Note: Start date will be considered from last settlement end date for each merchant.</p> */}
                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>

                        <CustomButton
                            style={{
                                padding: "8px",
                                // backgroundColor: "#fff",
                                // color: "#000",
                                minWidth: "100px",   // ← Add this
                            }}
                            variant="contained"
                            onClick={handleCancel}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px",
                                minWidth: "100px",
                            }}
                            onClick={createSettlementFun}
                            disabled={createSettlementReportRes.isLoading} // ✅ prevent double-click
                        >
                            {createSettlementReportRes.isLoading ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                    style={{ width: "16px", height: "16px" }}
                                />
                            ) : (
                                "Create"
                            )}
                        </CustomButton>
                        {/* 
                        <CustomButton
                            style={{
                                padding: "8px",
                                minWidth: "100px",   // ← Add this
                            }}
                            onClick={createSettlementFun}
                        
                        >
                            Create
                        </CustomButton>  */}
                    </DialogActions>
                </Dialog>
            </div >

            {/* ✅ FIX 2, 3, 4: Single unified notification popup using notificationType state */}
            <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                <DialogContent
                    className="text-center"
                    style={{ backgroundColor: "#00b9f51c" }}
                >
                    <img
                        src={notificationType === "success" ? success : failed}
                        alt=""
                        width="100px"
                        className="my-2"
                    />
                </DialogContent>
                <DialogContent>
                    <h3 style={{ margin: "0 20px", fontSize: "15px", textAlign: "center" }}>
                        {/* ✅ Shows API description e.g. "Created Succesfully" */}
                        {notificationMessage}
                    </h3>
                </DialogContent>
                <DialogActions style={{ justifyContent: "center" }}>
                    <CustomButton
                        style={{ color: "white" }}
                        variant="contained"
                        onClick={handleNoticationClose}
                    >
                        Ok
                    </CustomButton>
                </DialogActions>
            </Dialog>


        </>
    )
}

export default SettlementReport